<template>
  <div id="adminCrmInterventions">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">{{ admin }}</li>
      <li class="breadcrumb-item">{{ crm }}</li>
      <li class="breadcrumb-item active">
        <router-link :to="url">{{ Interventions }}</router-link>
      </li>
    </ol>
    <!--
          <div class="container-fluid">
            <div class="card">          
        <div class="tab-content noborder">
          <div class="card-body">
            <div class="row">
              <div class="col-3 text-left">
                <select2
                  id="select_AdminPagesView_IdLanguage"
                  ref="select_AdminPagesView_IdLanguage"
                  class="form-control nopadding"
                  style="width:75%"
                  :filterable="false"
                  service="languages"
                  v-model="
                    pageValueSelected.languagePageSetting.idLanguage
                  "
                  :default="defaultLanguageOptions"
                  :change="languageChange"                
                />
                <span>{{ language }}</span>
                          </div>
                        </div>
                     </div>
                  </div>
                </div>
   </div>
    -->
    <div class="container-fluid">
      <div class="card">
        <div class="tab-content">
          <div class="tab-pane active" id="tabTable" role="tabpanel">
            <div class="row">
              <div class="col-lg-6">
                <button
                  id="btnAdd"
                  type="button"
                  class="btn btn-sm btn-primary"
                  @click="onNewCategories"
                >
                  <i class="fa fa-plus"></i>
                  <span>{{ add }}</span>
                </button>
                <!--
                <button
                  id="btnSave"
                  type="button"
                  class="btn btn-sm btn-success"
                  @click="confirmSaveCategories"
                  :disabled="disableButton"
                >
                  <i class="fa fa-floppy-o"></i>
                  <span>{{ save }}</span>
                </button>
                -->
              </div>
            </div>      
            <div class="row">
              <div class="col-sm-12">
                <bootstrapTable
                  :configurations="tableConfiguration"
                  :datas="tableData"
                  id="tableCategories"
                  :onCheck="onTableCheckCategories"
                  :onCheckAll="onTableCheckCategories"
                  :onUncheck="onTableCheckCategories"
                  :onUncheckAll="onTableCheckCategories"
                  ref="tableCategories"
                  :results="tableResult"
                ></bootstrapTable>
              </div>
            </div>
          </div>
         
          <div class="tab-pane nopadding" id="tabDetail" role="tabpanel">
            <div class="card-header">{{newTitleInterventions}}</div>
           
             <div class="row">
          <div class="col-sm-6">
             <legend align="center">Interventi</legend>
              <hr>
            <div class="card-body">
              <div class="row">
                <pageDetail
                  functions="adminCrmInterventions"
                  :configurations="detailConfiguration"
                  :jsonValue="detailData"
                ></pageDetail>
              </div>
              <br>
              <div class="row">
                <div class="col-12">
                  <legend>Section Take Photos</legend>
                  <hr>
                </div>
                <div class="col-4">
                    <Camera v-on:takePicture="this.takePicture" />
                </div>
                <div class="col-8">
                  <Picture 
                  :captures="captures"
                   />
                </div>
              </div>           
            </div>
              </div>
               <div class="col-sm-6">
                <legend align="center">ModuloGuasti</legend>
                <hr>
                <div class="card-body">
                  <div class="row">
                <pageDetail
                  functions="adminCrmInterventions"
                  :configurations="detailModuleConfiguration"
                  :jsonValue="detailData"
                ></pageDetail>
                  </div>
               </div>
                 <div class="row">
                <div class="col-12 text-right">
                  <button
                    type="button"
                    class="btn btn-danger"
                    data-dismiss="modal"
                    @click="confirmCancelNewCategories"
                  >{{ cancel }}</button>
                  <button
                    type="button"
                    class="btn btn-success"
                    @click="confirmSaveNewCategories"
                  >{{ save }}</button>
                </div>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
import BootstrapTable from "@/components/BootstrapTable.vue";
import PageDetail from "@/components/PageDetail.vue";
import Select2 from "@/components/Select2.vue";
import WebCam  from "@/components/webcam.vue";
import Camera from  "@/components/Camera.vue";
import Picture from  "@/components/Picture.vue";


export default {
  name: "adminCrmInterventions",
  components: {
    BootstrapTable,
    Select2,
    PageDetail,
    "vue-web-cam": WebCam,
    Camera,
    Picture

  },
  data: function() {
    return {
      add: dictionaryHelpers.getDictionary("Add"),
      language: dictionaryHelpers.getDictionary("Language"),
      admin: dictionaryHelpers.getDictionary("Admin"),
      camera: dictionaryHelpers.getDictionary("Camera"),
      cancel: dictionaryHelpers.getDictionary("Cancel"),
      crm: dictionaryHelpers.getDictionary("CRM"),
      Interventions: dictionaryHelpers.getDictionary("Interventions"),
      del: dictionaryHelpers.getDictionary("Delete"),
      deleteCompleted: dictionaryHelpers.getDictionary("DeleteCompleted"),
      detailConfiguration: [],
      detailModuleConfiguration: [],
      captures: [],
      detailData: {},
      languages: 0,
      disableButton: true,
      insertCompleted: dictionaryHelpers.getDictionary("InsertCompleted"),
      newTitleInterventions: dictionaryHelpers.getDictionary("newTitleInterventions"),
      openDetail: dictionaryHelpers.getDictionary("OpenDetail"),
      save: dictionaryHelpers.getDictionary("Save"),
      defaultLanguageOptions: [],
      pageValueSelected: {
      id: 0,
      camera: 0,
      languagePageSetting: { content: null }
      },
      tableConfiguration: [],
      tableCustomerResult: [],
      tableData: [],
      tableResult: [],
      titleDetail: null,
      updateCompleted: dictionaryHelpers.getDictionary("UpdateCompleted"),
      url: window.location.pathname,
      rowIdSelected: 0,
      rowsSelected: 0
    };
  },
  created() {
    var adminCrmInterventions = this;
    
    spinnerHelpers.show();
    
    this.languages = storageData.sIdLanguage();

    adminCrmInterventions.defaultLanguageOptions = {
      id: storageData.sIdLanguage(),
      text: storageData.sDescriptionLanguage()
    };

        adminConfigurationServices.getFunctionality(function(result) {
        adminCrmInterventions.tableConfiguration = result.data.tablesConfigurations[0].tablesConfigurations;
        adminCrmInterventions.detailConfiguration = result.data.tabsConfigurations[0].pageConfigurations;
        adminCrmInterventions.detailModuleConfiguration = result.data.tabsConfigurations[1].pageConfigurations;

      adminCrmInterventions.loadTable();
    });
  },


  methods: {
    loadTable(ln) {
      var adminCrmInterventions = this;
      if(!functionHelpers.isValued(ln)){
        ln = storageData.sIdLanguage();
      }else{
        ln = this.languages;
      }
      InterventionsServices.getAll(ln,function(result) {
        adminCrmInterventions.tableData = result.data;
        spinnerHelpers.hide();
      });
    },

takePicture () {
  
  let ratio = (window.innerHeight < window.innerWidth) ? 16 / 9 : 9 / 16;
  const picture = document.querySelector("canvas");
  picture.width = (window.innerWidth < 1280) ? window.innerWidth : 1280;
  picture.height = window.innerWidth /  ratio; 
  const ctx = picture.getContext("2d");
  ctx.imageSmoothingEnabled = true;
  ctx.imageSmoothingQuality = "high";
  ctx.drawImage(document.querySelector("video"),0,0,picture.width,picture.height);
  
  if (this.detailData.captures.length < 4) {
    this.detailData.captures.push(canvas.toDataURL("image/png"));
    this.captures.push(canvas.toDataURL("image/png"));    
  }
},

    languageChange(value) {
      spinnerHelpers.show();
      var adminCrmInterventions = this;
      this.languages = value;
      adminCrmInterventions.loadTable(value);
      spinnerHelpers.hide();
    },
    InterventionsFormatter(value, row, index, field) {
      var adminCrmInterventions = this;
      var html =
       '<div class="container-fluid" style="min-width:80px;"><div class="row">';
      html +=
        '<button class="btn btn-success" onclick="adminCrmInterventions.__vue__.executeOpenDetail(' +
        row.id +
        ')"><i class="fa fa-pencil" title="' +
        this.openDetail +
        '" /></button>';
         html +=
        '<button class="btn btn-info" onclick="adminCrmInterventions.__vue__.clone(' +
        row.id +
        ')"><i class="fa fa-files-o"/></button>';
          html +=
        '<button class="btn btn-danger" onclick="adminCrmInterventions.__vue__.delete(' +
        row.id +
        ')"><i class="fa fa-trash"/></button>';


      if (functionHelpers.isValued(this.tableResult)) {
        $.each(this.tableResult, function(i, result) {
          if (result.id == row.id) {
            if (result.success) {
              html +=
                '<div class="col-1"><i class="fa fa-check text-success" title="';
              if (functionHelpers.isValued(result.message)) {
                html += result.message;
              } else {
                html += adminCrmInterventions.updateCompleted;
              }
              html += '" /></div>';
            } else {
              html +=
                '<div class="col-1"><i class="fa fa-exclamation-triangle text-danger" title="' +
                result.message +
                '" /></div>';
            }
            return;
          }
        });
      }
      html += "</div></div>";
      return html;
    },

    executeOpenDetail(id) {
      spinnerHelpers.show();
      var adminCrmInterventions = this;
      this.rowIdSelected = id;
      this.titleDetail = this.customer;
      this.captures=[];
      $.each(this.tableData, function(i, row) {
        if (adminCrmInterventions.rowIdSelected == row.id) {
          adminCrmInterventions.detailData = row;
          var capturesPhoto = row.captures;
          if (capturesPhoto.length > 0) {
            adminCrmInterventions.detailData.captures = [];
            for(var i=0;i<capturesPhoto.length;i++){
              adminCrmInterventions.detailData.captures.push(capturesPhoto[i].img);
              adminCrmInterventions.captures.push(capturesPhoto[i].img);    
            }
          }
        }
      });

    
      $("#tabTable").removeClass("active");
      $("#tabDetail").addClass("active");
      spinnerHelpers.hide();
    },

    clone(id) {
      var adminCrmInterventions = this;
      var ln = adminCrmInterventions.languages;
      spinnerHelpers.show();
      InterventionsServices.clone(id, function() {
        notificationHelpers.success(
          dictionaryHelpers.getDictionary("CloneCompleted")
        );
        
        if (!functionHelpers.isValued(ln)) {
          ln = storageData.sIdLanguage();
        }
        adminCrmInterventions.loadTable(ln);
      });
    },

    delete(id) {
      var adminCrmInterventions = this;
      var ln = adminCrmInterventions.languages;
      spinnerHelpers.show();
      InterventionsServices.del(id, function() {
        notificationHelpers.success(
          dictionaryHelpers.getDictionary("DeleteCompleted")
        );
        
        if (!functionHelpers.isValued(ln)) {
          ln = storageData.sIdLanguage();
        }
        adminCrmInterventions.loadTable(ln);
        window.scrollTo(0, 0);
      });
    },

      onNewCategories() {
      spinnerHelpers.show();
      var adminIntervention=this;

      this.detailData = {};
      
      this.detailData.captures = [];
      this.titleDetail = this.newCategories;
      this.rowIdSelected = 0;

      InterventionsServices.getLastId(function(result) {
        adminIntervention.detailData.id=result.data;
      });

      $("#tabTable").removeClass("active");
      $("#tabDetail").addClass("active");
      spinnerHelpers.hide();
    },

    confirmSaveCategories() {
      if (confirm(dictionaryHelpers.getDictionary("ConfirmSave"))) {
        this.executeSaveCategoriesSave();
      }
    },

    executeSaveCategoriesSave() {
      spinnerHelpers.show();
      var adminCrmInterventions = this;
      this.rowsSelected = 0;
      this.tableResult = [];

      $.each(this.$refs.tableCategories.getRowSelected(), function(i, row) {
        var rowToSave = row;
        rowToSave.idFunctionality = menuHelpers.getIdFunctionByAdminUrl();
        adminCrmInterventions.rowsSelected = adminCrmInterventions.rowsSelected + 1;
        //rowToSave.idlanguage=adminCrmInterventions.languages;

        InterventionsServices.update(
          rowToSave,
          function() {
            adminCrmInterventions.checkAllIsSaved();
            adminCrmInterventions.tableResult.push({
              id: rowToSave.id,
              success: true
            });
            notificationHelpers.success(adminCrmInterventions.updateCompleted);
          },
          function(response) {
            adminCrmInterventions.checkAllIsSaved();
            adminCrmInterventions.tableResult.push({
              id: rowToSave.id,
              success: false,
              message: response
            });
            notificationHelpers.error(response);
          }
        );
      });
    },

    confirmDeleteCategories() {
      if (confirm(this.confirmDelete)) {
        this.executeDeleteCategories();
      }
    },
    executeDeleteCategories() {
      spinnerHelpers.show();
      var adminCrmInterventions = this;
      this.rowsSelected = 0;
      this.tableResult = [];

      $.each(this.$refs.tableCategories.getRowSelected(), function(i, row) {
        adminCrmInterventions.rowsSelected = adminCrmInterventions.rowsSelected + 1;

        InterventionsServices.del(
          row.id,
          function() {
            adminCrmInterventions.checkAllIsSaved();
            notificationHelpers.success(adminCrmInterventions.deleteCompleted);
            
          },
          function(response) {
            adminCrmInterventions.checkAllIsSaved();
            adminCrmInterventions.tableResult.push({
              id: rowToSave.id,
              success: false,
              message: response
            });
            notificationHelpers.error(response);
          }
        );
      });
    },

    onTableCheckCategories() {
      var countRowSelected = this.$refs.tableCategories.countRowSelected();
      if (countRowSelected == 0) {
        this.disableButton = true;
      } else {
        this.disableButton = false;
      }
    },

    confirmCancelNewCategories() {
      if (confirm(dictionaryHelpers.getDictionary("ConfirmCancel"))) {
        this.executeCancelCategories();
      }
    },

    executeCancelCategories() {
      spinnerHelpers.show();
      this.detailTemplateEditorData = {};
      $("#tabTable").addClass("active");
      $("#tabDetail").removeClass("active");
      spinnerHelpers.hide();
    },

    confirmSaveNewCategories() {
      if (confirm(dictionaryHelpers.getDictionary("ConfirmSave"))) {
        this.executeSaveNewCategories();
      }
    },

    executeSaveNewCategories() {
      spinnerHelpers.show();
      var adminCrmInterventions = this;
      this.detailData.idFunctionality = menuHelpers.getIdFunctionByAdminUrl();

      if (!functionHelpers.isValued(this.detailData.code)) {
        this.detailData.code = false;
      }

      if (!functionHelpers.isValued(this.detailData.description)) {
        this.detailData.description = false;
      }

      if (!functionHelpers.isValued(this.languages)) {
        this.detailData.idLanguage = storageData.sIdLanguage();
      } else {
        this.detailData.idLanguage = this.languages;
      }

      if (
        functionHelpers.isValued(this.rowIdSelected) &&
        this.rowIdSelected > 0
      ) {
        this.detailData.id = this.rowIdSelected;

        InterventionsServices.update(this.detailData, function(result) {
          adminCrmInterventions.tableResult.push({
            id: result.data,
            success: true,
            message: adminCrmInterventions.updateCompleted
          });
          notificationHelpers.success(adminCrmInterventions.updateCompleted);
          adminCrmInterventions.loadTable(adminCrmInterventions.languages);
          $("#tabTable").addClass("active");
          $("#tabDetail").removeClass("active");
        });
      } else {
        
        InterventionsServices.insert(this.detailData, function(result) {
          adminCrmInterventions.tableResult.push({
            id: result.data,
            success: true,
            message: adminCrmInterventions.insertCompleted
          });
          notificationHelpers.success(adminCrmInterventions.insertCompleted);
          adminCrmInterventions.loadTable(adminCrmInterventions.languages);
          $("#tabTable").addClass("active");
          $("#tabDetail").removeClass("active");
        });
      }
    },
    changeTitle(field, value) {
      var adminPages = this;
      var titleToUrl = $("#description").val(),
        cleanUrl = "";
      cleanUrl =
        "/" +
        titleToUrl
          .replace(/([\/\,\!\\\^\$\{\}\[\]\(\)\.\*\+\?\|\<\>\-\&\s])/g, "-")
          .toLowerCase();
      if (
        adminPages.pageValueSelected.id == null ||
        $("#link").val() == ""
      ) {
        $("#link").val(cleanUrl);
        /*adminPages.pageValueSelected.languagePageSetting.url = dataHelpers.unbind(
          cleanUrl
        );*/
      }
      this.checkUrl(cleanUrl);
    },
    checkUrl(url) {
      if (url == "link") {
        url = $("#" + url).val();
      }
      var adminPages = this;

      if (adminPages.rowIdSelected == null) {
        pageServices.checkExistUrl(url, function(result) {
          if (result.data) {
            validationHelpers.setDetailError(
              "link",
              dictionaryHelpers.getDictionary("UrlAlreadyExist")
            );
          } else {
            $("#link").removeClass("error");
            validationHelpers.clear("#frmadminCrmCategories");
          }
        });
      } else {
        pageServices.checkExistUrlNotForThisPage(
          url,
          adminPages.rowIdSelected,
          function(result) {
            if (result.data) {
              validationHelpers.setDetailError(
                "link",
                dictionaryHelpers.getDictionary("UrlAlreadyExist")
              );
            } else {
              $("#link").removeClass("error");
              validationHelpers.clear("#frmadminCrmCategories");
            }
          }
        );
      }
    },
    checkAllIsSaved() {
      this.rowsSelected = this.rowsSelected - 1;
      if (this.rowsSelected == 0) {
        this.disableButton = true;
        this.loadTable(this.languages);
      }
    }
  }

};
</script>

<style lang="scss">
body {
  //font-family:'Avenir',Helvetica,Arial,sans-serif;
  margin: 0;
  padding:0;
  background-color: #f3f3f3;
}

textarea#description {
    margin-top: 0px;
    margin-bottom: 0px;
    height: 100px !important;
}
textarea#defect {
    margin-top: 0px;
    margin-bottom: 0px;
    height: 100px !important;
}

input#id {
    margin-top: 0px;
    margin-bottom: 0px;
    width:120px !important;
}


textarea#description {
    margin-top: 0px;
    margin-bottom: 0px;
    height: 150px !important;
}
textarea#defect {
    margin-top: 0px;
    margin-bottom: 0px;
    height: 150px !important;
}

textarea#voltage {
    margin-top: 0px;
    margin-bottom: 0px;
    height: 150px !important;
}


textarea#exit_notes {
    margin-top: 0px;
    margin-bottom: 0px;
    height: 100px !important;
}


div.col-sm-6 {
  border-right: 1px solid #CDCDCD;
  
}



</style>
